import { DrugCategoriesComponent } from './../drug-categories/drug-categories.component';
import { Entity } from './../select-list/select-list.component';
import { ApiService } from './../../api.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-reporting-config',
  templateUrl: './reporting-config.component.html',
  styleUrls: ['./reporting-config.component.css']
})
export class ReportingConfigComponent implements OnInit {
  public title : string;
  constructor(public api: ApiService) { }

  ngOnInit() {
  }

  get reportTypeId() {
    var type = this.api.session.currentCriteria.reportConfig.selectedType;
    if (!type)
      return null;
    return type.id;
  }
  set reportTypeId(value) {
    let myVal = null;
    if (value !== null) {
      for(let i=0;i<this.api.session.reportTypes.length;i++){
        let report = this.api.session.reportTypes[i];
        if(report.id == value){
          myVal = report;
          break;
        }
      }
    }

    this.api.session.currentCriteria.reportConfig.selectedType = myVal;
  }

  get reportTypes() {
    return this.api.session.reportTypes;
  }

  get reportOptions() {
    return this.api.session.currentCriteria.reportConfig;
  }

  clear(){
    this.reportOptions.titleLine1 = null;
    this.reportOptions.titleLine2 = null;
    this.reportOptions.footerLine1 = null;
    this.reportOptions.footerLine2 = null;
  }
}
